import { parseCookies } from "nookies";
import { useEffect, useState, type JSX } from "react";
import { CookieKeys } from "../../types/cookie-keys";
import { ScrollDownArrowContainer, ScrollDownArrowWrapper, ScrollDownSVG } from "./ScrollDownArrow.styles"

type ScrollDownArrowProps = {
    content: JSX.Element
    hideOnMobile?: boolean
}

export const ScrollDownArrow = ({ content, hideOnMobile }: ScrollDownArrowProps) => {
    const [hasInviteBar, setHasInviteBar] = useState(false);

    useEffect(() => {
        const cookies = parseCookies();
        const name = cookies[CookieKeys.referral_name];
        const businessName = cookies[CookieKeys.business_name];

        if (name || businessName) setHasInviteBar(true);
    }, []);

    return <ScrollDownArrowContainer>
        <div>
            {content}
        </div>
        <ScrollDownArrowWrapper notificationBarOn={hasInviteBar} hideOnMobile={hideOnMobile}>
            <ScrollDownSVG width="68" height="23" viewBox="0 0 68 23" fill="none" xmlns="http://www.w3.org/2000/svg"  >
                <path d="M64 2.5L34.8512 20.4751C34.3811 20.765 33.6189 20.765 33.1488 20.4751L3.99999 2.5" stroke="#9CA1AA" strokeWidth="5" strokeLinecap="round" />
            </ScrollDownSVG>
        </ScrollDownArrowWrapper>
    </ScrollDownArrowContainer>
}